import { Component, OnDestroy, OnInit } from '@angular/core';
import { CustomerService } from '../../customer/customer.service';

import { BatchstampService } from '../../batchstamp/batchstamp.service';

import { FormBuilder, NgForm } from '@angular/forms';
import { Subject } from 'rxjs/Rx';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { EvsStampService } from '../../../../../common/services/EvsStamp.service';
import { PagerService } from '../../../../../common/services/Pagination.service';
import { ModalInfoService } from '../../../../../common/services/ModalInfo.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { ConfirmationService } from 'primeng/primeng';
import { Message } from 'primeng/components/common/message';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { environment } from '../../../../../../environments/environment';
import * as moment from 'moment';
import { ImageService } from '../../../../imageService';
import { ExportService } from '../../../../../common/services/Export.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;

@Component({
  selector: 'app-widthdrawal',
  templateUrl: './widthdrawal.component.html',
  styleUrls: ['./widthdrawal.component.css'],
  providers: [
    ConfirmationService,
    EvsAddressService,
    EvsStampService,
    BatchstampService,
    ImageService
  ]
})
export class WidthdrawalComponent implements OnInit, OnDestroy {
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';

  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public currentPage: number = 1;
  public totalRow: number = 0;
  public page_size: number = 10;
  public offset: number = 0;
  public pager: any = {};
  public withdrawals: any = [];
  public message: { class: string; content: string } = null;
  public error: string = '';
  public componentData = null;
  public routerChange: any;
  public model: any = {};
  public paramsQuery: any = {};
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public msgs: Message[] = [];

  public current_filter: any = {};
  public item_active: any = 0;
  public item_detail: any = {};
  loading_data = true;
  status: number = -1;

  public arr_sort = { name: null };

  guarantees: any = [];
  guaranteeCurentpage: number = 1;
  public guaranteeTotalRow: number = 0;
  public guaranteePage_size: number = 10;
  public guaranteePager: any = {};
  isSorting: any;
  isUpdate: Boolean = false;
  totalItem: any = 0;
  totalPage: any = 0;
  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  public messageExport = '';
  private langSub: Subscription;

  constructor(
    private _location: Location,
    private service: CustomerService,
    private pagerService: PagerService,
    private router: Router,
    public addressService: EvsAddressService,
    private confirmationService: ConfirmationService,
    private mdInfo: ModalInfoService,
    private activatedRoute: ActivatedRoute,
    private _fb: FormBuilder,
    private toastr: ToastrService,
    private evsStampService: EvsStampService,
    private batchstampService: BatchstampService,
    private imageService: ImageService,
    private exportService: ExportService,
    private translate: TranslateService,
  ) {
    this.item_detail = undefined;
  }

  ngOnInit() {
    var that = this;
    // $('#inputStart').datepicker({ format: 'dd-mm-yyyy' });
    // $('#inputEnd').datepicker({ format: 'dd-mm-yyyy' });
    $('.input-daterange').datepicker();
    this.initSelect2();
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.initSelect2();
    });
    $('#province').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
      var id = e.target.value;
      that.loadDistrictData(id, null);
    });
    $('#district').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
    });
    // this.clearDataForm();
    //this.getCity();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.isSorting = 'desc';
      if (params.batch_id) {
        this.current_filter.batch_id = params.batch_id;
        this.loadData(this.current_filter, this.isSorting);
      } else {
        this.loadData(this.current_filter, this.isSorting);
      }
    });

    //this.loadData();
  }

  initSelect2() {
    $('#status').select2({
      placeholder: this.translate.instant('TRANG_THAI_LABEL'),
      allowClear: false,
      minimumResultsForSearch: -1
    });
    $('#province').select2({
      placeholder: this.translate.instant('TINH_THANH'),
      allowClear: false
    });
    $('#district').select2({
      placeholder: this.translate.instant('QUAN_HUYEN_LABEL'),
      allowClear: false
    });
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  loadGuarantee() {
    var request = {};
    request['offset'] =
      this.guaranteePage_size *
      (this.guaranteeCurentpage <= 0 ? 0 : this.guaranteeCurentpage - 1);
    request['limit'] = this.guaranteePage_size;
    request['desc'] = 'created_time';

    if (this.item_detail.name) {
      request['customer_name'] = this.item_detail.name;
      this.evsStampService.getLogGuarantee(request).subscribe(data => {
        //console.log(data.data.logs)
        this.guarantees = data.data.logs;
      });
    }
  }

  clearDataForm() {
    var that = this;
    setTimeout(function () {
      that.dtOptions = {
        // config DataTable
        scrollX: true,
        destroy: true,
        dom: 'Bfrtip',
        buttons: [
          {
            extend: 'colvis',
            text: '<i class=\'icon wb-menu\'></i> Hiển thị',
            className: 'colvis btn btn-sm btn-primary second-btn'
          }
        ],
        bInfo: false,
        paging: false,
        language: {
          search: '_INPUT_',
          searchPlaceholder: 'Tìm kiếm...'
        }
      };
    }, 0);
  }

  getCity() {
    this.addressService.getCities().subscribe(res => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id
        });
      });
      this.cities = citiesList;
    });
  }

  loadDistrictData(id: number, i: any) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then(res => {
        let districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id
          });
        });
        this.districts = districts;
        if (i != null) {
          if (this.districts[this.item_detail.distributions[i].district - 1]) {
            this.item_detail.distributions[i].district = this.districts[
              this.item_detail.distributions[i].district - 1
            ].value;
          }
        }
      });
  }

  loadData(request: any = {}, sort: any) {
    this.loading_data = true;
    if (_.isEmpty(request)) {
      request = this.current_filter;
    }

    request.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    request.desc = 'id';
    delete request.desc;
    delete request.asc;
    // if (this.status !== -1) {
    //   request.status = this.status;
    // }
    request.sort_by = 'created_time:' + sort;
    this.batchstampService
      .getRestores(request)
      .toPromise()
      .then(
        res => {
          //console.log(res.data.store)
          this.loading_data = false;
          let error = res.error;
          if (res.status == 200 && res.error == false) {
            this.withdrawals = res.data.store;

            this.totalItem = res.data.total;
            var pageString = (this.totalItem / this.page_size).toString();
            var pageSplit = pageString.split('.');
            var last: any;
            var totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;

            for (let i = 0; i < this.withdrawals.length; i++) {
              if (
                this.withdrawals[i].prefix &&
                this.withdrawals[i].id_start &&
                this.withdrawals[i].id_end
              ) {
                this.withdrawals[i].serial = this.formatSerial(
                  this.withdrawals[i].id_start,
                  this.withdrawals[i].id_end,
                  this.withdrawals[i].prefix
                );
              }
              this.withdrawals[i].image = this.imageService.readSrcImage(
                this.withdrawals[i].image,
                'thumb_medium'
              );
              var stamp_services: any = [];
              if (this.withdrawals[i].services) {
                var services = this.withdrawals[i].services;
                var listServices = services.split(',');
                for (let h = 0; h < listServices.length; h++) {
                  switch (listServices[h]) {
                    case '1': {
                      stamp_services.push({
                        id: 1,
                        name: this.translate.instant('CHONG_GIA')
                      });
                      break;
                    }
                    case '2': {
                      stamp_services.push({
                        id: 2,
                        name: this.translate.instant('BAO_HANH')
                      });
                      break;
                    }
                    case '3': {
                      stamp_services.push({
                        id: 3,
                        name: this.translate.instant('TRAN_HANG')
                      });
                      break;
                    }
                    case '5': {
                      stamp_services.push({
                        id: 5,
                        name: this.translate.instant('DINH_DANH')
                      });
                      break;
                    }
                  }
                }
              }
              this.withdrawals[i]['list_stamp_services'] = stamp_services;
            }
            if (this.withdrawals.length > 0) {
              this.viewDetail(
                this.item_active,
                this.withdrawals[this.item_active]
              );
            }
            //   if (this.withdrawals.length > 0) {
            //     this.item_detail = this.withdrawals[0];
            //     this.loadGuarantee();
            //     this.item_active = 0;
            //     this.setPage(this.currentPage);
          }

          // } else {
          //   this.message = {
          //     class: 'alert dark alert-danger',
          //     content: res.status + ' : ' + res.message
          //   };
          //   this.withdrawals = [];
          //   $('html, body').animate({ scrollTop: 0 }, "slow");
          // }
        },
        err => {
          // this.message = { content: 'Load data: ' + err.message, class: "alert dark alert-danger" };
          // this.withdrawals = [];
          // // this.genDataTable();
          // $("html, body").animate({ scrollTop: 0 }, "slow");
        }
      );
  }

  viewDetail(i, data) {
    this.item_detail = null;
    if (this.isUpdate == true) {
      this.toastr.info('Thao tác cập nhật khách hàng đã bị hủy', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
    this.isUpdate = false;
    this.item_active = i;
    this.batchstampService.getRestoreDetail(data.id).subscribe(res => {
      if (!res.error) {
        console.log(1123, res.data)
        this.item_detail = res.data;
        if (this.item_detail.batch) {
          this.item_detail.batch.image = this.imageService.readSrcImage(
            this.item_detail.batch.image,
            'thumb_medium'
          );
        }
        var listServices: any = [];
        var services = this.item_detail.batch.services.split(',');
        for (let i = 0; i < services.length; i++) {
          switch (services[i]) {
            case '1': {
              listServices.push({
                id: 1,
                name: this.translate.instant('CHONG_GIA')
              });
              break;
            }
            case '2': {
              listServices.push({
                id: 2,
                name: this.translate.instant('BAO_HANH')
              });
              break;
            }
            case '3': {
              listServices.push({
                id: 3,
                name: this.translate.instant('TRAN_HANG')
              });
              break;
            }
            case '5': {
              listServices.push({
                id: 5,
                name: this.translate.instant('DINH_DANH')
              });
              break;
            }
          }
        }

        this.item_detail.batch['number'] = data.id_end - data.id_start + 1;
        this.item_detail.batch['serial'] = this.formatSerial(
          data.id_start,
          data.id_end,
          data.prefix
        );
        this.item_detail['list_stamp_services'] = listServices;
        for (let i = 0; i < this.item_detail.distributions.length; i++) {
          if (
            this.item_detail.distributions[i].prefix &&
            this.item_detail.distributions[i].id_start &&
            this.item_detail.distributions[i].id_end
          ) {
            this.item_detail.distributions[i].serial = this.formatSerial(
              this.item_detail.distributions[i].id_start,
              this.item_detail.distributions[i].id_end,
              this.item_detail.distributions[i].prefix
            );
          }
        }
      }
    });
    // this.item_detail = this.withdrawals[i];
    // this.loadGuarantee();
  }

  formatSerial(id_start, id_end, prefix) {
    let serial: string = '';
    id_end = id_end.toString();
    id_start = id_start.toString();
    if (id_end && id_start && prefix) {
      let pad = '000000';
      let serial_start = pad.substring(0, 6 - id_start.length) + id_start;
      let serial_end = pad.substring(0, 6 - id_end.length) + id_end;
      if ((prefix + '-' + serial_start) === (prefix + '-' + serial_end)) {
        serial = prefix + '-' + serial_start;

      } else {
        serial = prefix + '-' + serial_start + ' đến ' + prefix + '-' + serial_end;
      }

    }
    return serial;
  }

  onSubmit() {
    this.item_active = 0;
    this.getData();
  }

  getData() {
    this.item_detail = undefined;
    let modelQuery = <any>{};
    if ($('#name').val()) {
      modelQuery['batch_name'] = $('#name')
        .val()
        .toString();
    }
    if ($('#code').val()) {
      modelQuery['code'] = $('#code')
        .val()
        .toString();
    }
    if ($('#prefix').val()) {
      modelQuery['prefix'] = $('#prefix')
        .val()
        .toString();
    }
    if ($('#status').val()) {
      modelQuery['status'] = $('#status')
        .val()
        .toString();
    }
    if ($('#product_name').val()) {
      modelQuery['product_name'] = $('#product_name')
        .val()
        .toString();
    }
    console.log('$(\'#created_time\').val()', $('#created_time').val())
    if ($('#created_time').val()) {
      const date = $('#created_time').val();
      const listDate = date.toString().split(' - ');
      if (listDate.length > 1) {
        modelQuery.from = moment(listDate[0], ['DD/MM/YYYY'])['_d'].getTime() / 1000;
        modelQuery.to = moment(listDate[1], ['DD/MM/YYYY'])['_d'].getTime() / 1000;
      }
    }
    this.currentPage = 1;
    this.current_filter = modelQuery;
    this.loadData(modelQuery, this.isSorting);
  }

  delete(id) {
    this.confirmationService.confirm({
      message: 'Bạn chắc chắn muốn xóa không?',
      header: 'Xác nhận',
      icon: 'fa fa-trash',
      accept: () => {
        // this.service.deleteById(id).subscribe(response => {
        //     console.log('delete: ', response);
        //     if (response) {
        //         let mEror = response.error;
        //         if (mEror === false) {
        //             this.msgs = [{
        //                 severity: 'success',
        //                 summary: 'Thông báo',
        //                 detail: 'Xóa thành công'
        //             }];
        //         } else {
        //             this.msgs = [{
        //                 severity: 'error',
        //                 summary: 'Thông báo',
        //                 detail: 'Không thành công: ' + response.message
        //             }];
        //         }
        //         this.loadData(this.paramsQuery);
        //     }
        // });
      }
    });
  }

  resetForm(frm: NgForm) {
    this.status = -1;
    $('#name').val('');
    $('#code').val('');
    $('#prefix').val('');
    $('#status')
      .val('')
      .trigger('change');
    $('#product_name').val('');
    $('#province')
      .val('')
      .trigger('change');
    $('#district')
      .val('')
      .trigger('change');
    frm.reset();
    this.getData();
  }

  search(event, mode?: any) {
    switch (mode) {
      case 'name':
        this.model.name = event;
        break;
      default:
        this.model.name = event;
        break;
    }
    this.router.navigate([], {
      queryParams: this.model
    });
  }

  /* pagination */
  setPage(page: number) {
    this.item_active = 0;
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalPage) {
        page = this.totalPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(this.current_filter, this.isSorting);
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      if (page < 1) {
        page = 1;
      } else if (page > this.totalPage) {
        page = this.totalPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(this.current_filter, this.isSorting);
      }
    }
  }

  setGuaranteePage(page: number) {
    this.guaranteePager = this.pagerService.getPager(
      this.guaranteeTotalRow,
      this.guaranteeCurentpage,
      this.guaranteePage_size
    );
    if (page < 1) {
      page = 1;
    }
    if (page != this.guaranteeCurentpage) {
      this.guaranteeCurentpage = page;
      this.loadGuarantee();
    }
  }

  rowIndex(i: number) {
    if (this.currentPage == 1) {
      return i + 1;
    } else {
      return this.page_size * (this.currentPage - 1) + (i + 1); //currentPage start from: 0
    }
  }

  handleUpdated(event) {
    if (event) {
      this.loadData(this.paramsQuery, this.isSorting);
    }
  }

  backToComponent() {
    this._location.back();
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  goGuaranteePage2(toPage: number) {
    //console.log(toPage);
    if (!toPage) {
      toPage = 1;
    }
    if (toPage && toPage > 0) {
      this.setGuaranteePage(toPage);
    }
  }

  setSort(typeSort: string) {
    this.currentPage = 1;
    this.isSorting = typeSort;
    this.loadData(null, typeSort);
  }

  backUpdateWork(event) {
    this.isUpdate = false;
    if ((event.isBack = false)) {
      this.setSort(this.isSorting);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  restoreDistribution(id: any) {
    this.confirmationService.confirm({
      message: 'Bạn chắc chắn muốn phục hồi tem trong khoảng này không?',
      header: 'Xác nhận',
      icon: 'fa fa-trash',
      accept: () => {
        var body: any = {
          batch_id: this.item_detail.batch_id,
          id_start: this.item_detail.id_start,
          id_end: this.item_detail.id_end,
          status: 0
        };
        this.batchstampService.restoreStamp(body).subscribe(res => {
          if (!res.error) {
            this.loadData(null, this.isSorting);
            this.toastr.success('Phục hồi thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        });
      }
    });
  }

  downloadExcel() {
    let modelQuery = <any>{};
    if ($('#name').val()) {
      modelQuery['batch_name'] = $('#name')
        .val()
        .toString();
    }
    if ($('#prefix').val()) {
      modelQuery['prefix'] = $('#prefix')
        .val()
        .toString();
    }
    if ($('#status').val()) {
      modelQuery['status'] = $('#status')
        .val()
        .toString();
    }
    if ($('#product_name').val()) {
      modelQuery['product_name'] = $('#product_name')
        .val()
        .toString();
    }
    let from = $('#inputStart').val();
    if (from) {
      let ar_from = from.split('-');
      let d = new Date(
        parseInt(ar_from[2]),
        parseInt(ar_from[1]) - 1,
        parseInt(ar_from[0]),
        0,
        0,
        0
      );
      modelQuery.from = d.getTime() / 1000;
    }
    let to = $('#inputEnd').val();
    if (to) {
      let ar_to = to.split('-');
      let d = new Date(
        parseInt(ar_to[2]),
        parseInt(ar_to[1]) - 1,
        parseInt(ar_to[0]),
        23,
        59,
        59
      );
      modelQuery.to = d.getTime() / 1000;
    }
    var url = environment.api_evs + '/restores/excel?';

    if (modelQuery.batch_name) {
      url += 'batch_name=' + modelQuery.batch_name;
    }
    if (modelQuery.prefix) {
      url += '&prefix=' + modelQuery.prefix;
    }
    if (modelQuery.product_name) {
      url += '&product_name=' + modelQuery.product_name;
    }
    if (modelQuery.from) {
      url += '&from=' + modelQuery.from;
    }
    if (modelQuery.to) {
      url += '&to=' + modelQuery.to;
    }
    if (modelQuery.status) {
      url += '&status=' + modelQuery.status;
    }

    url += '&sort_by=created_time:' + this.isSorting;
    if (localStorage.getItem('Access-Token')) {
      url += '&Access_Token=' + localStorage.getItem('Access-Token');
    }
    location.href = url;
  }

  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  exportReport() {
    console.log('this.isSorting', this.isSorting)
    this.messageExport = '';
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    const modelQuery = <any>{};
    if ($('#name').val()) {
      modelQuery['batch_name'] = $('#name').val().toString();
    }
    if ($('#code').val()) {
      modelQuery['code'] = $('#code').val().toString();
    }
    if ($('#prefix').val()) {
      modelQuery['prefix'] = $('#prefix').val().toString();
    }
    if ($('#status').val()) {
      modelQuery['status'] = $('#status').val().toString();
    }
    if ($('#product_name').val()) {
      modelQuery['product_name'] = $('#product_name').val().toString();
    }
    if ($('#created_time').val()) {
      const date = $('#created_time').val();
      const listDate = date.toString().split(' - ');
      if (listDate.length > 1) {
        modelQuery.from = moment(listDate[0], ['DD/MM/YYYY'])['_d'].getTime() / 1000;
        modelQuery.to = moment(listDate[1], ['DD/MM/YYYY'])['_d'].getTime() / 1000;
      }
    }
    // if ($('#created_time').val()) {
    //   const date = $('#created_time').val();
    //   const listDate = date.toString().split(' - ');
    //   if (listDate.length > 1) {
    //     const from = listDate[0].split('/')
    //     const to = listDate[1].split('/')
    //     modelQuery.from = from[2] + '-' + from[1] + '-' + from[0];
    //     modelQuery.to = to[2] + '-' + to[1] + '-' + to[0];
    //   }
    // }
    modelQuery.sort = `created_time:${this.isSorting}`
    const body = {
      exportTypeEnum: 'STAMP_LOCK_HISTORY',
      fields: modelQuery
    };
    this.exportService.exportReport(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('HE_THONG_DANG_XU_LY');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        $('.stampBoxStampAlertAdd').css('opacity', '0');
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/widthdrawal/widthdrawal/widthdrawal.component.ts